export default __webpack_public_path__ + "static/hair-care-914b0b9bf7526dc906d6edf428e04671.png";